import React from "react";
import '../Components/CSS/Global.css'

const PrivacyPolicy = () => {
  return (
    <div className="policy-hbt">
      <h1>Privacy Policy</h1>
      <p>Last Updated: March 2025</p>

      <section>
        <h2>1. Introduction</h2>
        <p>
          Welcome to <strong>100billion Tech</strong>. Your privacy is important to us, and we are 
          committed to protecting the personal information you share with us. This Privacy Policy 
          outlines how we collect, use, and safeguard your data when you visit our website or use our services.
        </p>
      </section>

      <section>
        <h2>2. Information We Collect</h2>
        <p>We collect various types of information, including:</p>
        <ul>
          <li><strong>Personal Information:</strong> Name, email address, phone number, company name, and other details you provide when contacting us.</li>
          <li><strong>Technical Data:</strong> IP address, browser type, device information, operating system, and other system details.</li>
          <li><strong>Usage Data:</strong> Pages visited, time spent on the website, interactions, and referral sources.</li>
          <li><strong>Cookies and Tracking Technologies:</strong> We use cookies to enhance user experience, analyze traffic, and improve our services.</li>
        </ul>
      </section>

      <section>
        <h2>3. How We Use Your Information</h2>
        <p>Your information is used for the following purposes:</p>
        <ul>
          <li>To provide, operate, and improve our services and website.</li>
          <li>To communicate with you regarding inquiries, support, and updates.</li>
          <li>To process transactions and manage customer accounts.</li>
          <li>To send marketing communications, promotions, and newsletters (if you opt-in).</li>
          <li>To ensure security, detect fraud, and protect against unauthorized access.</li>
          <li>To comply with legal obligations and enforce our policies.</li>
        </ul>
      </section>

      <section>
        <h2>4. Data Sharing and Disclosure</h2>
        <p>We do not sell, trade, or rent your personal information. However, we may share your data in the following cases:</p>
        <ul>
          <li><strong>Third-Party Service Providers:</strong> We may share data with trusted partners for hosting, analytics, and payment processing.</li>
          <li><strong>Legal Compliance:</strong> If required by law, we may disclose your information to authorities.</li>
          <li><strong>Business Transfers:</strong> In case of a merger, sale, or acquisition, your data may be transferred to the new entity.</li>
        </ul>
      </section>

      <section>
        <h2>5. Data Security</h2>
        <p>
          We implement industry-standard security measures to protect your data. However, no internet transmission 
          is 100% secure. We encourage users to take precautions when sharing sensitive information online.
        </p>
      </section>

      <section>
        <h2>6. Your Rights</h2>
        <p>You have the following rights regarding your personal data:</p>
        <ul>
          <li><strong>Access and Correction:</strong> You can request access to your data and correct inaccuracies.</li>
          <li><strong>Deletion:</strong> You may request deletion of your personal data under certain conditions.</li>
          <li><strong>Opt-Out:</strong> You can opt out of marketing emails at any time.</li>
          <li><strong>Data Portability:</strong> You can request a copy of your personal data.</li>
        </ul>
      </section>

      <section>
        <h2>7. Cookies and Tracking Technologies</h2>
        <p>
          Our website uses cookies to enhance your browsing experience. You can manage cookie preferences in your 
          browser settings. Disabling cookies may affect website functionality.
        </p>
      </section>

      <section>
        <h2>8. Third-Party Links</h2>
        <p>
          Our website may contain links to external sites. We are not responsible for the privacy practices of third-party 
          websites and encourage users to review their policies.
        </p>
      </section>

      <section>
        <h2>9. Children's Privacy</h2>
        <p>
          Our services are not intended for individuals under 13 years of age. We do not knowingly collect personal data 
          from children. If you believe a child has provided us with personal information, please contact us for removal.
        </p>
      </section>

      <section>
        <h2>10. Policy Updates</h2>
        <p>
          We may update this Privacy Policy from time to time. Changes will be posted on this page with the updated date. 
          Continued use of our services after updates constitutes acceptance of the new terms.
        </p>
      </section>

      <section>
        <h2>11. Contact Us</h2>
        <p>
          If you have any questions or concerns regarding this Privacy Policy, please contact us:
          <br />
          <strong>Email:</strong> support@100billiontech.com  
          <br />
          <strong>Phone:</strong> +91 8433-803-555  
          <br />
          <strong>Website:</strong> <a href="https://100billiontech.com" target="_blank" rel="noopener noreferrer">100billiontech.com</a>
        </p>
      </section>
    </div>
  );
};

export default PrivacyPolicy;
